<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">

  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista==='ListaPedidos'"
                    [innTemplateButton]="innTemplateButtonPedidos"
                    [innTemplate]="enviarTemplatePedidos" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonPedidos>
  </ng-template>
  <ng-template #enviarTemplatePedidos>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [loading]="loading"
                                 [mostrarBotonVerde]="false">
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <ag-grid-angular #agGrid (gridReady)="onGridReadyPedidos($event)" [columnDefs]="columnDefsPedidos"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponentsPedidos"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                         [pagination]="true" [rowData]="rowDataPedidos"
                         [rowSelection]="rowSelectionPedidos" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.idPedidos}}">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>

  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista==='ListaExtractos'"
                    [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formularioExtractos" class="form-group" novalidate>
      <div class="row">
        <div class="row mb-4">
          <div class="form-group col-md-3">
            <app-lfsa-combo-box (change)="getExtractos(rowSelected)" [comboBox]="cmbBanco"
                                [control]="this.formularioExtractos.get('idBanco') | formControl" [idOpcion]="'idBanco'"
                                [id]="'idBanco'"
                                [label]="'Banco'" [opcion]="'dscaBanco'"
                                [isReadOnly] = "true"
                                [habilitar]="false"
                                [disabled]="true"
                                formControlName="idBanco"></app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [claseLabel]="'letrasDanger'"
                            [control]="formularioExtractos.get('fechaContable_inicio') | formControl"
                            [id]="'fechaContable_inicio'"
                            [label]="'Fecha Desde*'" [mostrarImg]="false" [placeholder]="'Fecha desde...'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fechaContable_inicio">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
          <app-lfsa-input [claseLabel]="'letrasDanger'"
                          [control]="formularioExtractos.get('fechaContable_fin') | formControl"
                          [id]="'fechaContable_fin'"
                          [label]="'Fecha hasta*'" [mostrarImg]="false" [placeholder]="'Fecha hasta...'"
                          [rutaImagen]=""
                          [type]="'date'"
                          formControlName="fechaContable_fin">
          </app-lfsa-input>
        </div>
          <div class="form-group col-md-3">
            <div class="input-group mt-4">
              <div class="input-group-prepend">
                <button class="btn btn-primary" type="button" (click)="getExtractosv2(rowSelected)">
                  <i class="fa fa-search"></i> Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [formularioValido]="validateForm()"
                                 [loading]="loading"
                                 [textBoton]="textBoton"
    >
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <!--        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>-->
        <ag-grid-angular #agGrid (gridReady)="onGridReadyExtractos($event)" [columnDefs]="columnDefsExtractos"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponentsExtractos"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion" [pagination]="true"
                         [rowData]="rowDataExtractos"
                         [rowSelection]="rowSelectionExtractos"
                         [suppressRowClickSelection]="true" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.idExtractos}}">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>

  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista ==='ListaCobros'"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row mb-4">
          <div class="form-group col-md-2">
            <app-lfsa-input [claseLabel]="'letrasDanger'"
                            [control]="formulario.get('fecha_cobro_desde') | formControl"
                            [id]="'fecha_cobro_desde'"
                            [label]="'Fecha Desde*'" [mostrarImg]="false" [placeholder]="'Fecha desde...'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fecha_cobro_desde">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [claseLabel]="'letrasDanger'"
                            [control]="formulario.get('fecha_cobro_hasta') | formControl"
                            [id]="'fecha_cobro_hasta'"
                            [label]="'Fecha hasta*'" [mostrarImg]="false" [placeholder]="'Fecha hasta...'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fecha_cobro_hasta">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-select-opt-isp  (update)="formulario.get('pkBanco').setValue($event)"
                                      [claseLabel]="'letrasDanger'"
                                      [comboBox]="cmbBanco"
                                      [control]="formulario.get('pkBanco')"
                                      [idOpcion]="'idBanco'"
                                      [opcion]="'dscaBanco'"
                                      [id]="'pkBanco'"
                                      [label]="'Id Banco'"
                                      [clearContenido] ="true"
                                      formControlName="pkBanco">
            </app-lfsa-select-opt-isp>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('ctaBancaria') | formControl"
                            [id]="'ctaBancaria'"
                            [label]="'Cuenta'" [mostrarImg]="false" [placeholder]="'Cuenta'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="ctaBancaria">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('cliente') | formControl"
                            [id]="'cliente'"
                            [label]="'Cliente'" [mostrarImg]="false" [placeholder]="'Cliente'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="cliente">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('vendedor') | formControl"
                            [id]="'vendedor'"
                            [label]="'Vendedor'" [mostrarImg]="false" [placeholder]="'Vendedor'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="vendedor">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-combo-box [comboBox]="centers"
                                [control]="this.formulario.get('agencia') | formControl"
                                [idOpcion]="'idCentro'"
                                [opcion]="'nombreCentro'"
                                [id]="'agencia'"
                                [label]="'Division*'"
                                formControlName="agencia">

            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('fecha_doc_desde') | formControl"
                            [id]="'fecha_doc_desde'"
                            [label]="'Fecha Desde Doc*'" [mostrarImg]="false" [placeholder]="'Fecha desde...'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fecha_doc_desde">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('fecha_doc_hasta') | formControl"
                            [id]="'fecha_doc_hasta'"
                            [label]="'Fecha hasta Doc*'" [mostrarImg]="false" [placeholder]="'Fecha hasta...'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fecha_doc_hasta">
            </app-lfsa-input>
          </div>

          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('num_doc') | formControl"
                            [id]="'num_doc'"
                            [label]="'Referencia/Asignacion'" [mostrarImg]="false" [placeholder]="'Documento...'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="num_doc">
            </app-lfsa-input>
          </div>

          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('montoDesde') | formControl"
                            [id]="'montoDesde'"
                            [label]="'Monto desde'" [mostrarImg]="false" [placeholder]="'Monto desde...'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="montoDesde">
            </app-lfsa-input>
          </div>

          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('montoHasta') | formControl"
                            [id]="'montoHasta'"
                            [label]="'Monto hasta'" [mostrarImg]="false" [placeholder]="'Monto hasta...'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="montoHasta">
            </app-lfsa-input>
          </div>
          <!--          <div class="form-group col-md-4">
            <app-lfsa-combo-box [comboBox]="cmbTipoPago"
                                [control]="this.formulario.get('paymentType') | formControl" [idOpcion]="'tpagoId'"
                                [id]="'paymentType'"
                                [label]="'Tipo Pago'" [opcion]="'tpagoDescrip'"
                                formControlName="paymentType"></app-lfsa-combo-box>
          </div>-->
        </div>

        <div class="row mb-2 justify-content-center">
          <div class="col-md-12 d-flex justify-content-center">
            <button type="submit" class="btn btn-primary" [disabled]="!formulario.valid" (click)="cargarCobros()">
              <i class="fas fa-search mr-2"></i>Buscar
            </button>
            <button type="button" class="btn btn-danger mx-2" (click)="resetForm()">
              <i class="fas fa-eraser mr-2"></i>Limpiar
            </button>
          </div>
        </div>

      </form>
      <div *ngIf="mostrarTabla" class="row">
        <div class="col-md-12 " style="background-color: #f5f5f5;">
          <div class="btn-toolbar justify-content-sm-start mb-2" role="toolbar" aria-label="Toolbar with button groups">
            <div class="btn-group" role="group" aria-label="Second group">
              <button type="button" class="btn btn-outline-primary" (click)="agruparExtractos()" [disabled]="this.lb_activa_botton">
                <i class="fa fa-object-group"></i> Agrupacion Cobros
              </button>
            </div>
          </div>
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                           [pagination]="true" [rowData]="rowData"
                           [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                           id="{{diccionarioModulo.agGrid.id}}"
                           [localeText]="l10nAgGrid"
                           [gridOptions]="gridOptions">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>

<!-- T.23147 -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
  [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <form [formGroup]="motivosForm" class="form-group"  [formGroup]="motivosForm" novalidate>
    <div style="display: flex; width: 100%; border: 1px solid #aeaff1">
      <!-- Primera columna -->
      <div style="flex: 1; margin: 2px;">
          <div style="padding: 10px;">
            <label style="font-weight:bold;">SELECCIONE MOTIVO (s): </label>
            <ul>
              <input (change)="activarCamposRechazo($event);" formControlName="motivo1" 
              id="motivo1" type="checkbox"/> Error banco
            </ul>
            <ul>
              <input (change)="activarCamposRechazo($event);" formControlName="motivo2" 
              id="motivo2" type="checkbox"/> Error referencia
            </ul>
            <ul>
              <input (change)="activarCamposRechazo($event);" formControlName="motivo3" 
              id="motivo3" type="checkbox"/> Error fecha
            </ul>
            <ul>
              <input (change)="activarCamposRechazo($event);" formControlName="motivo4" 
              id="motivo4" type="checkbox"/> Error importe
            </ul>
            <ul>
              <input (change)="activarCamposRechazo($event);" formControlName="motivo5" 
              id="motivo5" type="checkbox"/> Error tipo de pago
            </ul>
            <ul>
              <input (change)="activarCamposRechazo($event);" formControlName="motivo6"  
              id="motivo6" type="checkbox"/> Duplicado
            </ul>
            <ul>
              <input (change)="activarCamposRechazo($event);" formControlName="motivo7"  
              id="motivo7" type="checkbox"/> Sin registros coincidentes
            </ul>
          </div>
      </div>

      <!-- Segunda columna -->
      <div style="flex: 1; margin: 2px;">
          <div style="padding: 10px;">
            <app-lfsa-input [control]="motivosForm.get('infbanco') | formControl" [id]="'infbanco'" [label]="'Banco'"
              formControlName="infbanco" type="text" style="font-weight:bold;"></app-lfsa-input>
          </div>
          <div style="padding: 10px; ">
            <app-lfsa-input [control]="motivosForm.get('infRef') | formControl" [id]="'infRef'" [label]="'Referencia'"
              formControlName="infRef" type="number" style="font-weight:bold;"></app-lfsa-input>
          </div>
          <div style="padding: 10px; ">
            <app-lfsa-input [control]="motivosForm.get('infFecha') | formControl" [id]="'infFecha'" [label]="'Fecha'"
              formControlName="infFecha" type="text" style="font-weight:bold;"></app-lfsa-input>
          </div>
      </div>

      <!-- Tercera columna -->
      <div style="flex: 1;  margin: 2px;">
          <div style="padding: 10px; ">
            <app-lfsa-input [control]="motivosForm.get('infimporte') | formControl" [id]="'infimporte'" [label]="'Importe'"
              formControlName="infimporte" type="number" style="font-weight:bold;"></app-lfsa-input>
          </div>
          <div style="padding: 10px; ">
            <app-lfsa-input [control]="motivosForm.get('inftipopago') | formControl" [id]="'inftipopago'" [label]="'T.Pago'"
              formControlName="inftipopago" type="text" style="font-weight:bold;"></app-lfsa-input>
          </div>
          <div style="padding: 10px; ">Otros 
            <textarea  placeholder="Otros" class="form-control rounded-0" rows="4" formControlName="infotros"
          maxlength="75"></textarea>
            <!--
            <app-lfsa-input [control]="motivosForm.get('infotros') | formControl" [id]="'infotros'" [label]="'Otros'"
              formControlName="infotros" type="textarea" style="font-weight:bold;" cols="300" rows="10"></app-lfsa-input>
            -->
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" data-bs-dismiss="modal" #close>Cancelar</button>
      <button type="button" formControlName="btnModalRechazo"  class="btn btn-danger mx-2" (click)="validarDatosRechazo()">Rechazar Cobro</button>
    </div>
  </form>
</ng-template>
<!-- END MODAL T.23147-->